<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 px-3 d-flex justify-content-between">
        <div class="s-20 font-weight-600 text-black">Continue Payment with</div>
      </div>
      <div class="col-md-12 mt-4">
        <div
          v-for="(gateway, index) in enrichedGateways"
          :key="gateway.id || index"
          class="row row-button c-pointer border-top d-flex justify-content-center py-3"
          @click="initializePayment(gateway)"
        >
          <!-- Show logo if available -->
          <img
            v-if="gateway.normalizedImage"
            :src="gateway.normalizedImage"
            :alt="gateway.displayName || gateway.gatewayName"
            style="width: 150px; max-height: 60px; object-fit: contain"
          />

          <!-- Fallback to text if image not found -->
          <span v-else class="text-dark font-weight-600">
            {{ gateway.displayName || gateway.gatewayName }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <el-dialog
    v-model="showPayPal"
    title=""
    class="expiredSubDialog border-radius-20"
    :width="mdAndUp || lgAndUp || xlAndUp ? `50%` : `90%`"
    align-center
    :show-close="true"
  >
    <div class="row">
      <div class="col-md-11 col-12">
        <div
          class="col-md-12 s-20 text-black text-center font-weight-bold text-head"
        >
          Prove of Payment
        </div>
        <div class="col-md-12 s-18 text-black text-center mt-4">
          Send Your Prove Of Payment or login detail to this Email
        </div>
        <div
          class="col-md-12 s-18 text-black mt-2 d-flex font-weight-600 text-center justify-content-center text-head"
        >
          <span class="mr-2">Email:</span>
          <span>churchplusnig@gmail.com</span>
        </div>
        <div class="d-flex col-md-12 mt-4 justify-content-center">
          <a
            href="https://www.paypal.me/GeorgeOnyeama?locale.x=en_GB"
            target="_blank"
          >
            <el-button
              class="ml-3 primary-bg text-white"
              @click="continueWithPayment"
              round
            >
              Continue
            </el-button>
          </a>
        </div>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    v-model="showDirectTransfer"
    title=""
    class="border-radius-20"
    :width="mdAndUp || lgAndUp || xlAndUp ? `40%` : `90%`"
    align-center
    :show-close="true"
  >
    <div class="row justify-content-center">
      <div class="col-md-11 col-12 subb px-4 py-3 mt-4 card-bg">
        <div class="row pb-2">
          <div class="gradient-text font-weight-600 col-md-8 s-20">
            Direct Bank Transfer details
          </div>
          <div class="col-md-12 pb-2">
            <div class="row mt-3">
              <div class="col-md-12 d-flex justify-content-between">
                <div class="text-dak fw-400">Account Name:</div>
                <span class="fw-500 text-dak">Complustech Limited</span>
              </div>
              <div class="col-md-12 d-flex justify-content-between">
                <div class="text-dak fw-400">Account Number:</div>
                <span class="fw-500 text-dak">0017934252</span>
              </div>
              <div class="col-md-12 d-flex justify-content-between">
                <div class="text-dak fw-400">Bank:</div>
                <span class="fw-500 text-dak">Access</span>
              </div>
              <div class="col-md-12 d-flex justify-content-between">
                <div class="text-dak fw-400">
                  Send Prove Of Payment or login detail to:
                </div>
                <span class="fw-500 text-dak">08023739961</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    v-model="showPaymentOptionModal"
    title=""
    class="border-radius-20"
    :width="mdAndUp || lgAndUp || xlAndUp ? `30%` : `90%`"
    align-center
    :show-close="true"
  >
    <div class="row justify-content-center">
      <div class="col-md-11 col-12">
        <!-- Payment Options -->
        <div class="col-md-12 px-0 font-weight-600 gradient-text">
          Direct Bank Transfer
        </div>
        <div class="text-dak px-0 col-md-12">I am paying from</div>
        <div class="col-md-12 px-0 mt-3">
          <div
            v-for="(option, index) in paymentOptions"
            :key="index"
            class="d-flex justify-content-between align-items-center py-3"
            :class="{ 'border-botto': index < 1 }"
          >
            <div class="fw-400 text-dak s-24">{{ option.label }}</div>
            <div>
              <input
                type="radio"
                name="paymentLocation"
                :value="option.value"
                v-model="selectedOption"
                @change="setSelectedOption(selectedOption)"
                class="form-check-inp"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, computed, watchEffect } from "vue";
import axios from "@/gateway/backendapi";
import { ElNotification } from "element-plus";
import deviceBreakpoint from "../../mixins/deviceBreakpoint";
import { useRouter } from "vue-router";

// ✅ define props & emits directly
const props = defineProps({
  formData: Object,
  donation: Object,
  close: Object,
  amount: Number,
  converted: Number,
  name: String,
  email: String,
  currency: String,
  entityType: Number,
  callPayment: Boolean,
  initializePaymentResponse: Object,
});

const emit = defineEmits([
  "selected-gateway",
  "transaction-reference",
  "paystack-amount",
  "payment-successful",
  "resetcallpaymentprops",
]);

// ✅ state
const isProduction = true;
const selectedGateway = ref("");
const showDirectTransfer = ref(false);
const showPayPal = ref(false);
const selectedOption = ref("");
const router = useRouter();
const showPaymentOptionModal = ref(false);
const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();

const normalizeImagePath = (path) => {
  if (!path) return "";
  if (path.startsWith("http") || path.startsWith("https")) {
    return path;
  }
  const cleanPath = path.replace(/(\.\.\/)+/, "").trim();

  try {
    return require(`@/assets/${cleanPath.split("/").pop()}`);
  } catch (err) {
    console.log("Image not found:", cleanPath);
    return "";
  }
};

const enrichedGateways = computed(() => {
  const formData = props.formData || {};
  const gateways = formData.paymentGateWays || [];
  const gatewayOptions = formData.paymentGateWayOptions || [];

  // ✅ Prefer paymentGateWays if available, otherwise fallback to options
  const source = gateways.length > 0 ? gateways : gatewayOptions;

  return source.map((pg) => {
    // Handle structure differences between the two
    const isOption = !!pg.churchPaymentGateway;

    const gateway = isOption
      ? pg.churchPaymentGateway?.gateway || {}
      : pg.paymentGateway || {};

    const churchGateway = isOption ? pg.churchPaymentGateway || {} : pg;

    const gatewayName =
      gateway.name || churchGateway.displayName || "Unknown Gateway";

    const buttonImagePath = gateway.imageUrl || "";
    const normalizedImage = buttonImagePath
      ? normalizeImagePath(buttonImagePath)
      : "";

    // Match with button configs if available
    const btnConfig = formData.gatewayButtons?.find(
      (b) => b.name === gatewayName
    );

    return {
      id: pg.id,
      gatewayName,
      displayName: churchGateway.displayName || gatewayName,
      buttonImagePath,
      normalizedImage: normalizedImage || btnConfig?.buttonImagePath || "",
      method: btnConfig?.method || "",
      subAccountID: churchGateway.config?.subAccountId || pg.subAccountID,
    };
  });
});
const setPayPal = () => {
  showPayPal.value = true;
};
const continueWithPayment = () => {
  showPayPal.value = false;
};
const setDirectTransfer = () => {
  showPaymentOptionModal.value = true;
};
const paymentOptions = ref([
  { label: "United States", value: "us" },
  { label: "Nigeria/Africa", value: "ng" },
]);
const setSelectedOption = (value) => {
  if (value === "us") initializePayment(2);
  else showDirectTransfer.value = true;
};

const initializePayment = (gateway) => {
  selectedGateway.value = (
    gateway.gatewayName ||
    gateway.displayName ||
    ""
  ).toLowerCase();
  emit("selected-gateway", selectedGateway.value);
};

const confirmDonationPayment = async (trans_id, tx_ref) => {
  console.log(trans_id, tx_ref, "confirmDonationPayment");

  try {
    // 🔥 Map entity types to endpoints
    const endpoints = {
      1: `/ConfirmFormsPayment?id=${trans_id}&txnref=${tx_ref}`,
      2: `/ConfirmInitializeContributionAndPledgePayment?id=${trans_id}&txnref=${tx_ref}`,
      3: `/ConfirmEventRegistrationPayment?id=${trans_id}&txnref=${tx_ref}`,
    };

    // 🧠 FALLBACK: default donation endpoint
    const endpoint =
      endpoints[props.entityType] ||
      `/ConfirmDonationPayment?id=${trans_id}&txnref=${tx_ref}`;

    // 🚀 MAKE REQUEST
    const { data } = await axios.post(endpoint);

    if (data.status) {
      emit("payment-successful", true);
      ElNotification({
        type: "success",
        showClose: true,
        message:
          "Confirmation successful, Thank you for your purchase with ChurchPlus",
        duration: 8000,
      });
    } else {
      ElNotification({
        type: "error",
        showClose: true,
        message:
          "Confirmation failed, please contact support at info@churchplus.co",
        duration: 8000,
      });
    }
  } catch (error) {
    console.error(error);
    ElNotification({
      type: "error",
      showClose: true,
      message:
        "Confirmation failed, please contact support at info@churchplus.co",
      duration: 8000,
    });
  }
};

// ✅ Paystack payment
const payWithPaystack = (initializePaymentResponse) => {
  // props.close.click();
  let handler = PaystackPop.setup({
    key: process.env.VUE_APP_PAYSTACK_PUBLIC_KEY_LIVE,
    // key: process.env.VUE_APP_PAYSTACK_API_KEY,
    email: props.email,
    amount: props.converted * 100 ? props.converted * 100 : props.amount * 100,
    firstname: props.name,
    ref: initializePaymentResponse.transactionReference,
    channels: ["card", "bank", "ussd", "qr", "mobile_money", "bank_transfer"],
    subaccount: props.formData.paymentGateWayOptions.find((opt) => {
      return (
        opt.churchPaymentGateway?.gateway?.name.toLowerCase() ===
        selectedGateway.value.toLowerCase()
      );
    })?.churchPaymentGateway?.config?.subAccountId,
    // bearer: "subaccount",
    onClose: function () {
      ElNotification({
        type: "info",
        showClose: true,
        message: "You have cancelled the transaction",
        duration: 5000,
      });
    },
    callback: (response) => {
      emit("transaction-reference", response.trxref);
      emit("paystack-amount");
      console.log(response, "paystack");

      confirmDonationPayment(response.trxref, response.trxref);
    },
  });
  handler.openIframe();
};

// ✅ Flutterwave
const getFlutterwaveModules = () => {
  const script = document.createElement("script");
  script.src = !isProduction
    ? "https://ravemodal-dev.herokuapp.com/v3.js"
    : "https://checkout.flutterwave.com/v3.js";
  document.getElementsByTagName("head")[0].appendChild(script);
};
getFlutterwaveModules();

const payWithFlutterwave = (initializePaymentResponse) => {
  console.log(initializePaymentResponse, "flutterwave");
  // props.close.click();

  window.FlutterwaveCheckout({
    public_key: process.env.VUE_APP_FLUTTERWAVE_PUBLIC_KEY_LIVE,
    tx_ref: initializePaymentResponse.transactionReference,
    amount: props.amount,
    currency: props.currency,
    payment_options: "card,ussd",
    customer: {
      name: props.name,
      email: props.email,
    },
    subaccounts: [
      {
        id: props.formData.paymentGateWayOptions.find((opt) => {
          return (
            opt.churchPaymentGateway?.gateway?.name.toLowerCase() ===
            selectedGateway.value.toLowerCase()
          );
        })?.churchPaymentGateway?.config?.subAccountId,
      },
    ],
    callback: (response) => {
      emit("transaction-reference", response.transaction_id);
      confirmDonationPayment(response.transaction_id, response.tx_ref);
    },
    onclose: () => console.log("Payment closed"),
    customizations: {
      title: props.formData.churchName,
      description: "Payment for contribution items",
      logo: props.formData.churchLogo,
    },
  });
};

// ✅ Watcher
watchEffect(() => {
  if (props.initializePaymentResponse) {
    if (
      props.callPayment &&
      Object.keys(props.initializePaymentResponse).length > 0
    ) {
      if (selectedGateway.value == "paystack") {
        payWithPaystack(props.initializePaymentResponse);
      } else if (selectedGateway.value == "flutterwave") {
        payWithFlutterwave(props.initializePaymentResponse);
      } else {
        const currentRoute = router.currentRoute.value.fullPath;
        const sourceParam = encodeURIComponent(currentRoute);
        sessionStorage.setItem(
          "previousRoute",
          router.currentRoute.value.fullPath
        );

        let paymentUrl = props.initializePaymentResponse?.paymentUrl;
        if (!paymentUrl.includes("source=")) {
          const separator = paymentUrl.includes("?") ? "&" : "?";
          paymentUrl += `${separator}source=${sourceParam}`;
        }

        window.open(paymentUrl);
      }

      emit("resetcallpaymentprops", false);
    }
  }
});
</script>

<style scoped>
.continue-text {
  font-family: Nunito Sans !important;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}

.option-text {
  font-family: Nunito Sans !important;
  font-weight: 800;
}

.circle {
  color: #136acd;
  font-size: 8px;
}

.hover-shadow:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
  cursor: pointer;
}

.row-button {
  padding: 15px;
  border-bottom: 1px solid #bfd7ff;
  transition: all 0.4s ease-in-out;
  max-height: 70px;
}

.img-height {
  max-height: 36px;
}

.row-button:hover {
  cursor: pointer;
  transform: scale(1.05, 1.05);
}

.img-pay {
  width: 125px;
}
.gradient-text {
  background: linear-gradient(90deg, #671414 0%, #0b55d5 100%);
  background-clip: text;
  color: transparent;
}
.card-bg {
  background: #fafafa;
}
.subb {
  background: #fafafa;
  border: 1px solid #d3d3d3;
  border-radius: 8px;
}
</style>
